import type { JSX } from '@builder.io/qwik';
import { Slot, component$ } from '@builder.io/qwik';

export default component$((): JSX.Element => {
  return (
    <main class='min-w-0 flex-1'>
      <div class='viewablity-block'>
        <Slot />
      </div>
    </main>
  );
});
